import { render, staticRenderFns } from "./BoxesStatusPage.vue?vue&type=template&id=901ee0e0&"
import script from "./BoxesStatusPage.vue?vue&type=script&lang=js&"
export * from "./BoxesStatusPage.vue?vue&type=script&lang=js&"
import style0 from "./BoxesStatusPage.vue?vue&type=style&index=0&id=901ee0e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports